import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, api_crud_base, endpoints } from './Config';

import { reqPOST, reqGET, repo_icons_link } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
	const [, set_dados] = useState(null);
	const forfaits = useRef(null);
	const equipments = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [date_search, set_date_search] = useState('')

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);

    const get_info = async (year, month, day) => {

        let n_forfaits = 0
		let n_equipments = 0
		let result = await reqGET(`${api_crud_base}/store/order/year/month/day/paied/${getTokenInfo().companycode}/${year}/${month}/${day}`)

        if(result !== undefined && result !== null && result.data.length > 0) {
            for await(let el of result.data) {
                el.info.documento.linhas.forEach(el_l => {
                    if(el_l.designacao.toLowerCase().includes('forfait')) {

                        // console.log('el_l', el_l)
                        // console.log('el_l.designacao', el_l.designacao)
                        // console.log('el_l.quantidade', el_l.quantidade)

                        if(el_l.designacao.toLowerCase().includes('fam')) {
                            n_forfaits = parseInt(n_forfaits) + parseInt(parseInt(el_l.quantidade) * 4)
                        }
                        else {
                            n_forfaits = parseInt(n_forfaits) + parseInt(el_l.quantidade)
                        }
                    }
                    if(el_l.designacao.toLowerCase().includes('equipamento')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                    if(el_l.designacao.toLowerCase().includes('capacete')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                    if(el_l.designacao.toLowerCase().includes('botas')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                    if(el_l.designacao.toLowerCase().includes('skis')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                    if(el_l.designacao.toLowerCase().includes('bast')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                    if(el_l.designacao.toLowerCase().includes('prancha')) {
                        n_equipments = parseInt(n_equipments) + parseInt(el_l.quantidade)
                    }
                })
            }

            setData(result.data);
            setLoading(false)

            set_dados(forfaits.current = n_forfaits)
            set_dados(equipments.current = n_equipments)
            // console.log('n_forfaits', n_forfaits)
            // console.log('n_equipments', n_equipments)

        }
        else {

        setData(result.data);
        setLoading(false)

        }

    }

    const get_info_id = (id_serch) => {
        reqGET(`${api_crud_route}/client/${getTokenInfo().companycode}/${id_serch}`)
            .then(res => {
                //console.log(res.data)
                setData(res.data);
                setLoading(false)
            })
            .catch(() => 404
        )
    }

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        if(getTokenInfo().profile === 'Cliente') {
            get_info_id(getTokenInfo().id)
        }
        else {
            get_info('*', '*', '*')
        }

        set_lang(localStorage.getItem('lang'))

        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            });
    }, [pathname, refresh]);

    //APAGAR REGISTO
    /*function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
    }*/

    const devolver = (id) => {

        Swal.fire({
			title: language[lang].return_title,
			text: language[lang].return_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].return_confirm,
			cancelButtonText: language[lang].return_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

                // Swal.fire('', 'id ' + id, 'info')
                // return

                reqPOST(`${api_crud_base}/estancia/anular`, {numencomenda: id})
                    .then(() => { 
                        window.location.reload();
                    })
                    .catch(() => Swal.fire(language[lang].return_error, '', 'info'))

			}
		})

    }

    const handle_change_info_detail_date = (e) => {
		const { value } = e.target;

		set_date_search(value)

        let aux = value.split('-')
        get_info(aux[0], aux[1], aux[2])

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

    const columns = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            sortable: true,
            left: true,
            minWidth: '50px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '18%',
        },
        {
            name: language[lang].field_email,
            selector: 'info.documento.user_info.username',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '18%',
        },
        {
            name: language[lang].field_total,
            selector: 'info.documento.total_documento',
            cell: row => 
                <span style={{fontFamily: 'Open Sans, sans-serif', fontVariantNumeric: "tabular-nums"}}>
                    {parseFloat(row.info.documento.total_documento).toFixed(2) + ' €'}
                </span>
            ,
            sortable: true,
            right: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: language[lang].field_tem_aula,
            selector: 'info.tem_aulas',
            cell: row => (
                row.info.tem_aulas === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i> </span>
                : 
                   <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 3 ? 
                                <span className="badge rounded-0" style={{backgrounColor: '#7952b3;'}}><i className="bi bi-check-lg text-white fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === 0 ? 
                                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                                : 
                                    parseInt(row.info.pagamento_pendente) === -2 ? 
                                        <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                    :
                                        <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '8%',
        },
        {
            name: 'Plataforma',
            selector: 'info.origin',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '5%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '100px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    {
                    parseInt(row.info.pagamento_pendente) === 1 ? 
                        <button className="button button-delete" onClick={() => devolver(row['id'])}>
                            <i className="bi bi-file-earmark-x"></i>
                        </button>
                    :
                        null
                    }
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                </span>
        },
    ];

    const columns_colaboradores = [
        {
            name: language[lang].field_n_encomenda,
            selector: 'id',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_date,
            selector: 'info.data',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_name,
            selector: 'info.documento.user_info.name',
            sortable: true,
            left: true,
            minWidth: '200px',
            maxWidth: '40%',
        },
        {
            name: language[lang].field_tem_aula,
            selector: 'info.tem_aulas',
            cell: row => (
                row.info.tem_aulas === true ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i> </span>
                : 
                   <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: language[lang].field_pagamento_pendente,
            selector: 'info.pagamento_pendente',
            cell: row => (
                parseInt(row.info.pagamento_pendente) === 1 ? 
                    <span className="badge rounded-0 bg-success"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                : 
                    parseInt(row.info.pagamento_pendente) === 2 ? 
                            <span className="badge rounded-0 bg-primary"><i className="bi bi-check-lg text-white fs-4"></i></span> 
                        : 
                            parseInt(row.info.pagamento_pendente) === 3 ? 
                                <span className="badge rounded-0" style={{backgrounColor: '#7952b3;'}}><i className="bi bi-check-lg text-white fs-4"></i></span> 
                            : 
                                parseInt(row.info.pagamento_pendente) === 0 ? 
                                    <span className="badge rounded-0 bg-warning"><i className="bi bi-exclamation-lg text-dark fs-4"></i></span> 
                                : 
                                    parseInt(row.info.pagamento_pendente) === -2 ? 
                                        <span className="badge rounded-0 bg-secondary"><i className="bi bi-arrow-return-left text-white fs-4"></i></span>
                                    :
                                        <span className="badge rounded-0 bg-danger"><i className="bi bi-x-lg text-white fs-4"></i></span>
            ),
            sortable: false,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: 'Plataforma',
            selector: 'info.origin',
            sortable: true,
            center: true,
            minWidth: '100px',
            maxWidth: '10%',
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '100px',
            maxWidth: '10%',
            cell: row => 
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>
                </span>
        }
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns: (getTokenInfo().profile === 'Gestor de Conteúdos' || getTokenInfo().profile === 'Administrador') ? columns : columns_colaboradores,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    }

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].component_list}</h2>
                <p>{language[lang].component} / {language[lang].component_list}</p>
            </div>

            <div className="information">
                <div className={`dash-cards-2 highlights`}>
                    <div className="card-single">
                        <div className="card-body">
                            <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>

                                <input type="date" className="form-control rounded-0" value={date_search} onChange={handle_change_info_detail_date} />

                            </div>
                        </div>
                    </div>
                    <div className="card-single">
                        <div className="card-body">
                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                    <img className="img-fluid" style={{maxHeight: '50px'}} alt='' src={repo_icons_link("icon-forfait.png")} />
                                </div>
                                <div className='text-end ms-2 me-3'>
                                    <h2 className='fs-3'>{forfaits.current !== undefined && forfaits.current !== null ? forfaits.current : '0' }</h2>
                                    <h6>{language[lang].forfaits}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-single">
                        <div className="card-body">
                            <div className='d-flex justify-content-between align-items-center' >
                                <div className='d-flex justify-content-between align-items-center' style={{height: '52px'}}>
                                    <img className="img-fluid" style={{maxHeight: '50px'}} alt='' src={repo_icons_link("icon-equipamento.png")} />
                                </div>
                                <div className='text-end ms-2 me-3'>
                                    <h2 className='fs-3'>{equipments.current !== undefined && equipments.current !== null ? equipments.current : '0' }</h2>
                                    <h6>{language[lang].equipments}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        
            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">
                        
                            <div className="pb-10">
                                <div className="div-table">
                                {
                                        permissions.edit ?
                                    <div className="table-header text-end">
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    :<></>
                                    }
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
        
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}